import { useTranslation } from "react-i18next";
import ThankYouMessage from "../../components/ThankYouMessage";
import Header from "../layout/Header";
import Footer from "../../group_travel/Footer";

const AuSignupRequest = () => {
  const { t } = useTranslation("pages", { keyPrefix: "groupTravel.newProduct.auSignupRequest" });

  return (
    <div className="flex flex-col justify-start min-h-[inherit]">
      <Header hideAccount={false} home={"/"} />
      <div className="mb-8">
        <ThankYouMessage t={t} additionalcontent={true} />
      </div>
      <Footer />
    </div>
  );
};
export default AuSignupRequest;
